import Login from "../Pages/Auth/Login";
import ForgotPassword from "Pages/ForgotPassword";
import HomePage from "../Pages/Home";
import LeaderBoard from "Pages/Leaderboard";
import Notifications from "Pages/Notifications";
import Settings from "Pages/Settings";
import CoreCurriculum from "Pages/CoreCurriculum";
import Classroom from "Pages/Classroom";
import Contest from "Pages/Contest";
import InviteFriends from "Pages/InviteFriends";
import CommunityClass from "Pages/CommunityClassroom";


import JoinSession from "Pages/JoinSession";
import Discussions from "Components/Classroom/ClassDetail/Questions/Discussions";
import Discussion from "Pages/DiscussionHub/index";

import Problems from "Pages/Problems";
import ManageCourse from "Pages/ManageCourse";

import MentorSessions from "Components/MockInterview/index6";
import Business from "Components/Business/Index";
import Teaching from "Components/TeachingHelp/index";
import Notes from "Components/Notes";
import PersonalDetails from "Pages/PersonalDetails";
import CareerHub from "Components/CareerHub/Index4";
import MockInterview from "Components/MockInterview/SessionGuideLines";
// import MockInterview from "Pages/MockInterview";

const publicRoutes = [
  { path: "/login", Component: <Login /> },
  { path: "/forgot-password", Component: <ForgotPassword /> },
  { path: "/mock-interview", Component: <MockInterview /> },
  { path: "/personal-details", Component: <PersonalDetails /> },
  { path: "/business", Component: <Business /> }
];

const privateRoutes = [
  { path: "/", Component: <HomePage /> },
  { path: "/global-leaderboard/", Component: <LeaderBoard /> },
  { path: "/global-leaderboard/:tab", Component: <LeaderBoard /> },
  { path: "/notifications", Component: <Notifications /> },
  { path: "/settings", Component: <Settings /> },
  { path: "/settings/:tab", Component: <Settings /> },
  { path: "/core-curriculum/", Component: <CoreCurriculum /> },
  { path: "/core-curriculum/:id/:tab", Component: <CoreCurriculum /> },
  { path: "/class/", Component: <Classroom /> },
  { path: "/class/:id", Component: <Classroom /> },
  // { path: "/class/:id/:tab", Component: <Classroom /> },
  // { path: "/class/:id/:tab/:subtab", Component: <Classroom /> },

  { path: "/session/:id/:sessionId/", Component: <Classroom /> },
  { path: "/session/:id/:sessionId/:tab", Component: <Classroom /> },
  { path: "/class/:id/:sessionId/:tab/:subtab", Component: <Classroom /> },

  { path: "/test", Component: <Contest /> },
  { path: "/test/:id", Component: <Contest /> },
  { path: "/test/:id/:tab", Component: <Contest /> },
  { path: "/invite-friends", Component: <InviteFriends /> },
  { path: "/community-class", Component: <CommunityClass /> },

  { path: "/discussions", Component: <Discussions /> },
  { path: "/discussion-hub", Component: <Discussion /> },
  { path: "/discussion-hub/:encryptPostId/:encryptUserId", Component: <Discussion /> },

  { path: "/problems", Component: <Problems /> },
  { path: "/course/:mainAction/:subAction", Component: <ManageCourse /> },

  { path: "/:pathName/:uid/:channelName/:classType/:roleId/:name", Component: <JoinSession /> },

  { path: "/mentor-sessions", Component: <MentorSessions /> },
  // { path: "/business", Component: <Business /> },
  { path: "/teaching", Component: <Teaching /> },
  { path: "/notes", Component: <Notes /> },
  // { path: "/personal-details", Component: <PersonalDetails /> },
  { path: "/career-hub", Component: <CareerHub /> },
  // { path: "/mock-interview", Component: <MockInterview /> }
];

export { publicRoutes, privateRoutes };
